'use client';

import Link from '@lichtblick/link';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import type { FC } from 'react';
import { buildUrl } from '../../helpers/links';
import type { SubnavigationItemType } from '../../types/storyblok';
import styles from './subnavigation.module.scss';

const SLASHES = /^\/+|\/+$/g;

export const SubnavigationItem: FC<SubnavigationItemType> = ({ label, link }) => {
  const pathname = usePathname();

  const href = buildUrl(link);

  if (!href) {
    return null;
  }

  return (
    <Link
      className={classNames([
        styles.item,
        pathname.replace(SLASHES, '') === href.replace(SLASHES, '') && styles.active,
      ])}
      href={href}
    >
      {label}
    </Link>
  );
};
